import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import { FitnessLevelType } from '../../store/fitnessLevelStore';
import { useStores } from '../../store/rootStore';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { trackOnboardingCollectedFitnessLevel } from '../../utils/analytics';

const CollectFitnessLevel = observer(() => {
  const { fitnessLevelStore, getNextPagePath } = useStores();
  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedFitnessLevel(
      fitnessLevelStore.selectedFitnessLevel,
    );
    navigate(getNextPagePath('CollectFitnessLevel'));
  };

  const handleClick = (selectedFitnessLevel: FitnessLevelType) => {
    fitnessLevelStore.setFitnessLevel(selectedFitnessLevel);
  };

  return (
    <Container>
      <ProgressBar currentPage={'CollectFitnessLevel'} />
      <PageHeader title="What is your fitness level?"></PageHeader>
      <Flex direction={'column'}>
        <RegularButton
          title="Beginner"
          subtitle="I don't work out"
          image="○"
          isSelected={fitnessLevelStore.selectedFitnessLevel === 'beginner'}
          onClick={() => handleClick('beginner')}
        />
        <RegularButton
          title="Intermediate"
          subtitle="I work out 2-3 times a week"
          image="△"
          value="Intermediate"
          isSelected={fitnessLevelStore.selectedFitnessLevel === 'intermediate'}
          onClick={() => handleClick('intermediate')}
        />
        <RegularButton
          title="Advanced"
          subtitle="I work out regularly"
          image="⬡"
          value="Advanced"
          isSelected={fitnessLevelStore.selectedFitnessLevel === 'advanced'}
          onClick={() => handleClick('advanced')}
        />
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={!fitnessLevelStore.selectedFitnessLevel}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectFitnessLevel;
